import { render, staticRenderFns } from "./ProcessedCorrespondenceEmailList.vue?vue&type=template&id=f013ade2&scoped=true"
import script from "./ProcessedCorrespondenceEmailList.vue?vue&type=script&lang=js"
export * from "./ProcessedCorrespondenceEmailList.vue?vue&type=script&lang=js"
import style0 from "./ProcessedCorrespondenceEmailList.vue?vue&type=style&index=0&id=f013ade2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013ade2",
  null
  
)

export default component.exports